var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    _vm._b(
      { attrs: { xs12: "", "pa-2": "", "ma-2": "" } },
      "v-flex",
      { [`sm${_vm.size}`]: true },
      false
    ),
    [
      _vm.property.type === "label"
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              staticClass: "caption",
            },
            [
              _vm._v(
                "\n              " +
                  _vm._s(_vm.property.label) +
                  ":\n              "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.type === "label"
        ? _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              staticClass: "caption",
            },
            [
              _vm._v(
                "\n              " +
                  _vm._s(_vm.resolvedApi) +
                  "\n              "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.password
        ? _c(
            "v-text-field",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              attrs: {
                autocomplete: "new-password",
                type: _vm.showPassword ? "text" : "password",
                label: _vm.property.label,
                rules: [_vm.rules.required],
                placeholder: _vm.property.hintText,
                hint: _vm.property.shortDescription,
                "persistent-hint": "",
                readonly: _vm.locked,
                clearable: !_vm.locked,
              },
              on: { input: _vm.changed },
              model: {
                value: _vm.property.value,
                callback: function ($$v) {
                  _vm.$set(_vm.property, "value", $$v)
                },
                expression: "property.value",
              },
            },
            [
              _vm.property.helpText
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "25%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c("v-icon", [_vm._v("fas fa-info-circle")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4007922847
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.property.helpText),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.property.password && _vm.property.type === "text"
        ? _c(
            "v-text-field",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              attrs: {
                autocomplete: "new-password",
                label: _vm.property.label,
                rules: [_vm.rules.required, _vm.rules.email, _vm.rules.format],
                placeholder: _vm.property.hintText,
                hint: _vm.property.shortDescription,
                "persistent-hint": "",
                readonly: _vm.locked,
                clearable: !_vm.locked,
              },
              on: { input: _vm.changed },
              model: {
                value: _vm.property.value,
                callback: function ($$v) {
                  _vm.$set(_vm.property, "value", $$v)
                },
                expression: "property.value",
              },
            },
            [
              _vm.property.helpText
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "25%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c("v-icon", [_vm._v("fas fa-info-circle")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4007922847
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.property.helpText),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.property.password && _vm.property.type === "textarea"
        ? _c(
            "v-textarea",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              attrs: {
                label: _vm.property.label,
                rules: [_vm.rules.required, _vm.rules.email, _vm.rules.format],
                placeholder: _vm.property.hintText,
                hint: _vm.property.shortDescription,
                "persistent-hint": "",
                readonly: _vm.locked,
                clearable: !_vm.locked,
              },
              on: { input: _vm.changed },
              model: {
                value: _vm.property.value,
                callback: function ($$v) {
                  _vm.$set(_vm.property, "value", $$v)
                },
                expression: "property.value",
              },
            },
            [
              _vm.property.helpText
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "25%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c("v-icon", [_vm._v("fas fa-info-circle")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4007922847
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.property.helpText),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.type === "checkbox"
        ? _c(
            "v-checkbox",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              attrs: {
                rules: [_vm.rules.required],
                label: _vm.property.label,
                readonly: _vm.locked,
              },
              on: { change: _vm.changed },
              model: {
                value: _vm.property.value,
                callback: function ($$v) {
                  _vm.$set(_vm.property, "value", $$v)
                },
                expression: "property.value",
              },
            },
            [
              _vm.property.helpText
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "25%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c("v-icon", [_vm._v("fas fa-info-circle")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4007922847
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.property.helpText),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.listOptions && _vm.property.type === "list"
        ? _c(
            "v-select",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              attrs: {
                items: _vm.listOptions,
                rules: [_vm.rules.required],
                label: _vm.property.label,
                readonly: _vm.locked,
                clearable: !_vm.locked,
              },
              on: { input: _vm.changed },
              model: {
                value: _vm.property.value,
                callback: function ($$v) {
                  _vm.$set(_vm.property, "value", $$v)
                },
                expression: "property.value",
              },
            },
            [
              _vm.property.helpText
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "", "max-width": "25%" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c("v-icon", [_vm._v("fas fa-info-circle")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4007922847
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          textContent: _vm._s(_vm.property.helpText),
                        },
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.type === "upload"
        ? _c(
            "v-layout",
            {
              class: { "grey lighten-2": _vm.dragover },
              attrs: { wrap: "" },
              on: {
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.onDrop($event)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = true
                },
                dragenter: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = true
                },
                dragleave: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = false
                },
              },
            },
            [
              _c(
                "v-flex",
                {
                  staticStyle: {
                    border: "5px dashed grey",
                    "align-items": "center",
                    "text-align": "center",
                  },
                  attrs: { xs12: "" },
                },
                [
                  _c(
                    "v-icon",
                    {
                      class: [_vm.dragover ? "mt-2, mb-6" : "mt-5"],
                      attrs: { size: "60" },
                    },
                    [
                      _vm._v(
                        "\n                fa-light fa-cloud-arrow-up\n              "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { textContent: _vm._s(_vm.property.hintText) },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticStyle: {
                    "align-items": "center",
                    "text-align": "center",
                  },
                  attrs: { xs12: "" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.visible,
                          expression: "visible",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.upload(_vm.property)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.property.label) +
                          "\n              "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.type === "link"
        ? _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.linkClick(_vm.property)
                },
              },
            },
            [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.property.label) +
                  "\n              "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.helpText && _vm.property.type === "link"
        ? _c(
            "v-tooltip",
            {
              attrs: { left: "", "max-width": "25%" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [_c("v-icon", [_vm._v("fas fa-info-circle")])]
                    },
                  },
                ],
                null,
                false,
                4007922847
              ),
            },
            [
              _vm._v(" "),
              _c("span", {
                domProps: { textContent: _vm._s(_vm.property.helpText) },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.property.shortDescription &&
      (_vm.property.type === "link" || _vm.property.type === "checkbox")
        ? _c("div", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.property.shortDescription) +
                "\n              "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.property.alert
        ? _c(
            "div",
            [
              _c("v-alert", { attrs: { value: true, type: "info" } }, [
                _vm._v(_vm._s(_vm.property.alert)),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "hide-overlay": "", persistent: "", width: "300" },
          model: {
            value: _vm.linkdialog,
            callback: function ($$v) {
              _vm.linkdialog = $$v
            },
            expression: "linkdialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n                    Please complete the steps in the adjacent tab or close the tab\n                    "
                  ),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "white" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }